import Product from "../Product";
import { products } from "../../json/products";

function PopularProducts() {
  return (
    <>
      <div className="flex items-center justify-center my-10">
        <p className="font-semibold text-2xl text-center">Shop by Products</p>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-3">

        {/* getting first 6products */}
        {products?.slice(0,6).map((item, index) => (
          <Product item={item} key={index} />
        ))}
      </div>
    </>
  );
}

export default PopularProducts;
